import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const Box = styled.div`
  position: relative;
  width: 100%;
  padding-right: 4px;
  input {
    width: 100%;
    border-radius: 4px;
    border: 1px solid;
    padding: 12px 8px 8px 8px;
    direction: ${props => (props.alignLeft ? "ltr" : "rtl")};
    border-color: ${props => {
      switch (props.status) {
        case "warning":
          return Variables.colors.yellow_500;
        case "error":
          return Variables.colors.red_600;
        case "success":
          return Variables.colors.green;
        default:
          return Variables.colors.complementary_500;
      }
    }};
    &:focus {
      border-color: ${props => {
        switch (props.status) {
          case "warning":
            return Variables.colors.yellow_500;
          case "error":
            return Variables.colors.red_600;
          case "success":
            return Variables.colors.green;
          default:
            return Variables.colors.primary_700;
        }
      }};
    }
  }
  label {
    position: absolute;
    right: 8px;
    font-size: ${Variables.font_sizes.x2_medium};
    transition: 0.1s;
    top: 10px;
    padding: 0 6px;
    color: ${props => {
      switch (props.status) {
        case "warning":
          return Variables.colors.yellow_500;
        case "error":
          return Variables.colors.red_600;
        case "success":
          return Variables.colors.green;
        default:
          return Variables.colors.complementary_700;
      }
    }};
    background-color: ${props =>
      props.focusStatus && props.labelStatus !== "top"
        ? "transparent!important"
        : ""};
    ${props => {
      if (props.labelStatus === "top") {
        return `            
            background-color: transparent;
            top: -6px;
            font-size: ${Variables.font_sizes.x_small};
            &:after {
              content: "";
              display: block;
              position: absolute;
              top: 6px;
              right: 0;
              width: 100%;
              height: 1px;
              background-color: ${Variables.colors.complementary};
              z-index: 1;
            }
            span {
              position: relative;
              z-index: 10;
            }
            `;
      }
    }}
  }
  .notice {
    margin-bottom: 8px;
    display: block;
    padding: 4px 0;
    position: absolute; //todo for accounting
    font-size: ${Variables.font_sizes.x_small};
    color: ${props => {
      switch (props.status) {
        case "warning":
          return Variables.colors.yellow_500;
        case "error":
          return Variables.colors.red_600;
        case "success":
          return Variables.colors.green;
        default:
          return Variables.colors.complementary_500;
      }
    }};
  }
`;
